import type { SVGProps } from 'react'

export const QrcodeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17 16.125V18H15.25M17 12.375H16.125L14.375 14.25M13.5 16.125H11.75V18M3 3H8.25V8.625H3V3ZM11.75 3H17V8.625H11.75V3ZM3 12.375H8.25V18H3V12.375ZM11.75 12.375V13.3125H12.625V12.375H11.75Z"
      stroke="#9BA1AD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
